<template>
  <div class="container">

    <div class="toppanel">
        <div class="segment">
            <div class="item" @click="goto('/review')">用户评价</div>
            <div class="item active">服务图集</div>
        </div>

<!--         <div class="title">用户评价</div>
 -->
        <div class="filter">

        </div>   
    </div>


    <div class="reviews" v-for="pics in galleryPics" >
        <div class="date">{{pics.date}}</div>
        <vue-picture-swipe :options="galleryOptions" :items="pics.info"></vue-picture-swipe>
    </div>



    <transition name="fade">
        <div id="loadingToast" v-show="isSending && galleryPics.length==0 ">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在加载相册</p>
            </div>
        </div>
    </transition>

  </div>

</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import anime from 'animejs';

export default {
  name: 'review',
  data () {
    return {
      isSending:false,
      galleryPics:[],
      reviewStop:false,
      currentDate:'',
      galleryOptions:{
        bgOpacity: 0.8,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: true,
        shareEl: false,
        arrowEl: false,
        tapToClose: true,
        showAnimationDuration :0,
        hideAnimationDuration :0
      }
    }
  },
  created: function () {
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    ifShowDate(mass){
        if(this.serviceFilter=='all'){
            return true
        }
        else if(mass[this.serviceFilter]>0){
            return true
        }
        else{
            return false
        }
    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 300,
            easing = arg.easing || 'easeInSine',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToTop(){
        this.scroll({
            to: '.toppanel'
        });
    },
    getPricing(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;
        let url = this.apiURL()+'/TradeRate/getRes';
        let apiObject = {};

        let newDay = new Date();
        let oldDay = new Date();

        if(this.currentDate){
            newDay = this.currentDate;
        }

        var oldDay = newDay - 1000 * 60 * 60 * 24 * 60;  
        oldDay = new Date(oldDay);

        apiObject.start_at = Vue.filter('moment')(oldDay,"YYYY-MM-DD");
        apiObject.end_at = Vue.filter('moment')(newDay,"YYYY-MM-DD");


        this.axios.post(url,qs.stringify(apiObject))
        .then(function (response) {
            console.log(response);
            if(response.data.data.length>0){
                if(that.galleryPics.length>0){
                    that.galleryPics = that.galleryPics.concat(response.data.data);
                }
                else{
                    that.galleryPics = response.data.data;
                }
                that.isSending = false;
                that.currentDate = oldDay;
            }
            else{
                that.reviewStop = true;
                that.isSending = false;
            }

        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
      }
    },
    onWaypoint ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        //this.getPricing();
      }

    }
  }
}

</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
    padding-top:90px;
}

.more{
    text-align:center;
    font-size:0.9em;
    color:#777;
}



.toppanel{
  position:fixed;
  left:0;
  top:0;
  padding-top:20px;
  width:100%;
  z-index:99;
  background:#fff;
  border-bottom:1px solid #f3f3f3;
}

.reviews{
    .date{
        font-size:1.3em;
        font-weight:bold;
        margin:20px 8px 8px 8px;
        color:#555;
    }
    .my-gallery{
        display: flex;
        justify-content:space-between;
    }

}

.filter{
    padding:12px 12px 15px 12px;
    display: flex;
    justify-content:space-around;
    .pill{
        display:inline-block;
        font-size:0.8em;
        background:#f6f6f6;
        padding:4px 12px;
        border-radius:20px;
        &.active{
            color:$color-orange;
            background:#fff0ee;
            font-weight:bold;
        }
    }
}


.title{
    font-size:16pt;
    padding:0;
}

.segment{
    background:#f5f5f5;
    border-radius:50px;
    width:70%;
    margin:0 auto;
    height:40px;
    display: flex;
    justify-content:space-between;
    margin-top:4px;
    .item{
        width:50%;
        text-align:center;
        font-size:1.2em;
        line-height:2.1em;
        font-weight:bold;
        color:#999;
        &.active{
            background:#ff7444;
            color:#fff;
            border-radius:50px;
            background-size: cover;
        }
    }
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.vehicle-img img{
    max-width:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/gallery.vue